import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';

export default function FundersHome() {
  const { api } = useAuth();
  const toast = useToast();
  const [funders, setFunders] = useState(null);
  const [adding, setAdding] = useState(false);
  const [form, setForm] = useState({ name: '', license_no: '', contact_phone: '', bank_iban: '', website: '', logo_path: '' });

  const load = useCallback(() => {
    api('/financial/funders').then(setFunders).catch((e) => toast.error(e.message));
  }, [api, toast]);
  useEffect(() => { load(); }, [load]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async () => {
    try {
      const body = {};
      Object.entries(form).forEach(([k, v]) => { if (v !== '') body[k] = v; });
      await api('/financial/funders', { method: 'POST', body: JSON.stringify(body) });
      toast.success('تمت إضافة الجهة');
      setForm({ name: '', license_no: '', contact_phone: '', bank_iban: '', website: '', logo_path: '' });
      setAdding(false);
      load();
    } catch (e) { toast.error(e.message); }
  };

  if (!funders) return <div className="loader">جاري التحميل...</div>;

  return (
    <div>
      <div className="card" style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
        <div>
          <div className="card-title">التقارير المالية متعددة المشاريع</div>
          <p style={{ color: 'var(--text-muted)', fontSize: 13, margin: '6px 0 0' }}>
            اختر الجهة الممولة لعرض سلسلة تقاريرها الشهرية.
          </p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <Link className="btn btn-outline btn-sm" to="/financial-settings">⚙ الأسعار والبنود</Link>
          <button className="btn btn-primary btn-sm" onClick={() => setAdding((v) => !v)}>＋ إضافة جهة ممولة</button>
        </div>
      </div>

      {adding && (
        <div className="card" style={{ marginBottom: 16, background: 'var(--surface-alt)' }}>
          <div className="card-title" style={{ marginBottom: 10 }}>جهة ممولة جديدة</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 10 }}>
            <F label="الاسم *"><input className="form-input" value={form.name} onChange={(e) => set('name', e.target.value)} /></F>
            <F label="رقم الترخيص"><input className="form-input" value={form.license_no} onChange={(e) => set('license_no', e.target.value)} /></F>
            <F label="هاتف التواصل"><input className="form-input" value={form.contact_phone} onChange={(e) => set('contact_phone', e.target.value)} /></F>
            <F label="الآيبان (IBAN)"><input className="form-input" value={form.bank_iban} onChange={(e) => set('bank_iban', e.target.value)} /></F>
            <F label="الموقع الإلكتروني"><input className="form-input" value={form.website} onChange={(e) => set('website', e.target.value)} /></F>
            <F label="مسار الشعار"><input className="form-input" value={form.logo_path} onChange={(e) => set('logo_path', e.target.value)} /></F>
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
            <button className="btn btn-primary btn-sm" onClick={submit} disabled={!form.name}>حفظ</button>
            <button className="btn btn-outline btn-sm" onClick={() => setAdding(false)}>إلغاء</button>
          </div>
        </div>
      )}

      {funders.length === 0 ? (
        <div className="empty">لا توجد جهات ممولة بعد — ابدأ بإضافة جهة من الزر أعلاه.</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 12 }}>
          {funders.map((f) => (
            <Link key={f.id} to={`/financial-reports/${f.id}`} className="card" style={{ textDecoration: 'none' }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--text)' }}>{f.name}</div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 6 }}>
                {f.projects_count ?? 0} مشروع{f.license_no ? ` · ترخيص ${f.license_no}` : ''}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

function F({ label, children }) {
  return (
    <div>
      <label className="form-label" style={{ fontSize: 12 }}>{label}</label>
      {children}
    </div>
  );
}
